import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Package2, PanelLeft } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "../../component/ui/tooltip";
import { Button } from "../../component/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { HiOutlineBars3 } from "react-icons/hi2";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb";
import {
  dashboardIcon,
  dashboardIconBlue,
  emailIcon,
  emailIconBlue,
  investorIcon,
  investorIconBlue,
  managmentIcon,
  reportIcon,
  reportIconBlue,
  uploadIcon,
  uploadIconBlue,
} from "../../assets/icons";
import { DataTable } from "../../component/table/dataTable";
import Investors from "../adminPage/Investors";
import Schemes from "../adminPage/Schemes";
import Ticker from "../adminPage/Ticker";
import EmailTemplate from "../adminPage/EmailTemplates";
import { UserManagement } from "../adminPage/UserManagement";
import { UploadData } from "../adminPage/UploadData";
import InvestorUploadReports from "../../component/investor/InvestorUploadReports";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { nullUserDetails } from "../../context/actions/userAction";
import Profile from "../../component/profile";

export function Layout() {
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const location=useLocation()
  const [collapsed, setCollapsed] = useState(true); // Sidebar state
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false); // Mobile sidebar state
const userInfo=useSelector(state=>state.user)
  const { selectedTab, setSelectedTab, selectedSubTab, setSelectedSubTab } =
    useBreadCrumb();

  const handleToggle = () => {
    setCollapsed(!collapsed); // Toggle collapsed state
  };

  const handleMobileSidebarToggle = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen); // Toggle mobile sidebar visibility
  };

  const handleTabClick = (tabName) => {
    setSelectedTab(tabName); // Set the selected tab on click
    if (isMobileSidebarOpen) {
      setIsMobileSidebarOpen(false); // Close the sidebar on mobile after selecting a tab
    }
  };

  useEffect(() => {
    setSelectedTab("Investors");
  }, []);

  const navigation = [
    {
      name: "Investors",
      href: "#",
      icon: investorIcon,
      icon2: investorIconBlue,
      current: selectedTab === "Investors",
    },
    {
      name: "Schemes",
      href: "#",
      icon: reportIcon,
      icon2: reportIconBlue,
      current: selectedTab === "Schemes",
    },
    {
      name: "User Management",
      href: "#",
      icon: managmentIcon,
      icon2: managmentIcon,
      current: selectedTab === "User Management",
    },
    {
      name: "Upload Data",
      href: "#",
      icon: uploadIcon,
      icon2: uploadIconBlue,
      current: selectedTab === "Upload Data",
    },
    {
      name: "Email Templates",
      href: "#",
      icon: emailIcon,
      icon2: emailIconBlue,
      current: selectedTab === "Email Templates",
    },
    {
      name: "Ticker",
      href: "#",
      icon: dashboardIcon,
      icon2: dashboardIconBlue,
      current: selectedTab === "Ticker",
    },
  ];
  const handleLogout=()=>{
    dispatch(loaderSet(true))
    dispatch(nullUserDetails())
    navigate("/")
    setTimeout(() => {
      dispatch(loaderSet(false))
    }, 3000);
    
  }

  const handleNavigateToProfile=()=>{
    dispatch(loaderSet(true))
    navigate("/employee/profile")
    setTimeout(() => {
      // dispatch(nullUserDetails())
      dispatch(loaderSet(false))
    }, 3000);
    
  }

  return (
    <TooltipProvider>
      <div className="flex min-h-screen w-full flex-col bg-muted/40">
        {/* Sidebar */}
        <aside
          className={`fixed inset-y-0 left-0 z-10 flex flex-col transition-all duration-300 ease-in-out bg-background ${
            collapsed ? "w-14" : "w-60"
          } ${isMobileSidebarOpen ? "block" : "hidden"} sm:flex`}
        >
          <nav className="flex flex-col items-center gap-4 px-2 py-5">
            {/* <Link
              href="#"
              className="group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full bg-[#0D215C] text-lg font-semibold text-primary-foreground"
            >
              <Package2 className="h-4 w-4 transition-all group-hover:scale-110" />
              <span className="sr-only">Acme Inc</span>
            </Link> */}
            {navigation.map((item, index) => (
              <Tooltip key={index}>
                <TooltipTrigger asChild>
                  <Link
                    to="/employee"
                    onClick={() => handleTabClick(item.name)} // Handle tab click
                    className={`flex items-center gap-4 px-2.5 h-9 w-full rounded-lg transition-colors hover:text-foreground ${
                      item.current ? "bg-accent text-[#0D215C]" : "text-black"
                    }`}
                  >
                    <span
                      className={`flex items-center ${
                        collapsed
                          ? "w-full justify-center"
                          : "w-auto justify-start"
                      }`}
                    >
                      <img
                        src={item.current ? item.icon2 : item.icon}
                        alt=""
                        className={`w-5 font-bold`}
                      />
                    </span>
                    {!collapsed && <span className=" ml-2">{item.name}</span>}
                  </Link>
                </TooltipTrigger>
                {collapsed && (
                  <TooltipContent side="right">{item.name}</TooltipContent>
                )}
              </Tooltip>
            ))}
          </nav>
          <button
            className="mt-auto mb-4 p-5 text-black w-full"
            onClick={handleToggle}
          >
            <PanelLeft className="h-5 w-5" />
          </button>
        </aside>

        {/* Main Content */}
        <div
          className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${
            collapsed ? "ml-14" : "ml-60"
          }`}
        >
          <header className="sticky w-full justify-between items-center top-0 z-30 flex h-14 gap-4 border-b bg-background px-4">
            <Breadcrumb className="hidden md:flex pl-5">
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/employee">Employee</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>{location.pathname==="/employee/profile"?"Profile":selectedTab}</BreadcrumbItem>
                                 </BreadcrumbList>
            </Breadcrumb>

            {/* Dropdown for mobile and avatar for desktop */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <div className="flex items-center">
                  {/* Avatar button for screens larger than 768px */}
                  <Button
                    variant="outline"
                    size="icon"
                    className="overflow-hidden rounded-full items-center hidden sm:flex"
                  >
                    <img
                     src={ userInfo && userInfo.image_url ? userInfo.image_url :  "./avatar.png"}
                      width={36}
                      height={36}
                      alt="Avatar"
                      className="overflow-hidden rounded-full"
                    />
                  </Button>
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
              <DropdownMenuItem><button onClick={()=>{handleNavigateToProfile()}} >Profile</button></DropdownMenuItem>
              <DropdownMenuItem><button onClick={()=>{handleLogout()}} >Logout</button></DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            {/* HiOutlineBars3 button for mobile */}
            <Button
              variant="outline"
              size="icon"
              className="sm:hidden"
              onClick={handleMobileSidebarToggle}
            >
              <HiOutlineBars3 size={24} />
            </Button>
          </header>
          <main className="flex-1 h-screen overflow-y-auto p-4">
            {/* Check if the current route is /admin/investor-upload-report */}
            { location.pathname==="/employee/profile"
            ? <Profile/>
            :
            
            location.pathname === "/employee/investor-upload-report" ? (
              <InvestorUploadReports  forWhichUserType={"employee"} />
            ) : (
              <>
                {/* Render content based on the selected tab */}
                {selectedTab === "Investors" && <Investors  employee={true} />}
                {selectedTab === "Schemes" && <Schemes  employee={true} />}
                {selectedTab === "User Management" && <UserManagement employee={true} />}
                {selectedTab === "Upload Data" && <UploadData  employee={true} />}
                {selectedTab === "Email Templates" && <EmailTemplate  employee={true} />}
                {selectedTab === "Ticker" && <Ticker  employee={true} />}
              </>
            )}
          </main>
      
        </div>
      </div>
    </TooltipProvider>
  );
}
